import { render, staticRenderFns } from "./internal-answers.vue?vue&type=template&id=7a0ed4ae"
import script from "./internal-answers.vue?vue&type=script&lang=js"
export * from "./internal-answers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports